module.exports = __webpack_public_path__ + "img/2.3c49be98.png";